import { useContext, useEffect, useState } from "react"
import { stateContext } from "./ctx"
import { icons } from "./icons"
import { deepCopy } from "./functions"
const History = () => {
    const {schema,setSchema,bgColor,setBgColor,hue,session,setHue} = useContext(stateContext)
    const [history,setHistory] = useState([])
    const [curStep,setCurStep] = useState(0)
    const [comesFromHistory,setComesFromHistory] = useState(false)

    useEffect(()=>{
        if (!comesFromHistory){
        const newHistory = deepCopy(history)
        const newOb = {date:Date.now(),data:{schema,bgColor,hue}};
        newHistory.unshift(newOb)
        setHistory(newHistory)
    } else {
        setComesFromHistory(false)
    }
        
    },[schema,bgColor,session])

    useEffect(()=>{
        if (history[curStep]){
            setSchema(history[curStep].data.schema)
            setBgColor(history[curStep].data.bgColor)
            setHue(history[curStep].data.hue)
        }
    },[curStep])

  
    const isUndoDisabled = curStep === history.length - 1 ? 'disabled' : ''
    const isRedoDisabled = curStep === 0 ? 'disabled' : ''

    return <>
    <div className={'btn '+isUndoDisabled} onClick={()=>{
        setComesFromHistory(true)
        setCurStep(curStep === history.length -1 ? history.length -1 : curStep +1)
    }}>{icons.undo}</div>
    <div className={'btn '+isRedoDisabled} onClick={()=>{
        setComesFromHistory(true)
        setCurStep(curStep === 0 ? 0 : curStep -1)
    }}>{icons.redo}</div>
    
    </>
}

export default History